import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IPlayerProfileStore } from './store';

export interface IPlayerProfileActions extends IActionGroup {
  get: (playerId: number) => { profile?: IPlayerProfileStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (_: IStore, playerId: number) => {
    const response = await request.get(`${api.player_profile}${playerId}`);

    if (response.error) {
      return {
        errors: {
          profile: {
            msg: 'Error fetching the player profile.'
          }
        }
      };
    }

    const profile = response;
    return {
      profile: {
        [playerId]: profile
      }
    };
  }
};

export default actions;
